import { cn } from '../lib/cn.js'

/**
 * Frase em Permanent Marker. Guia: "Só em frases curtas e levemente
 * inclinadas, no máximo uma por peça."
 *
 * O limite de uma por peça é disciplina de quem monta a tela — o componente
 * avisa em desenvolvimento quando a frase passa de 40 caracteres, que é onde
 * a fonte deixa de parecer escrita à mão e passa a parecer erro.
 */
export type DestaqueProps = {
  children: string
  cor?: 'amarelo' | 'branco' | 'preto' | undefined
  className?: string | undefined
}

export function Destaque({ children, cor = 'amarelo', className }: DestaqueProps) {
  // import.meta.env em vez de process.env: este pacote roda no browser e não
  // pode depender dos tipos do Node.
  const emDesenvolvimento =
    typeof import.meta !== 'undefined' &&
    (import.meta as { env?: { DEV?: boolean } }).env?.DEV === true
  if (emDesenvolvimento && children.length > 40) {
    console.warn(
      `[du/ui] Destaque com ${children.length} caracteres. O guia pede frase CURTA: "${children}"`,
    )
  }
  return <span className={cn('du-destaque', `du-destaque--${cor}`, className)}>{children}</span>
}
